<mat-horizontal-stepper [linear]="isLinear" #stepper (selectionChange)="changeStepper($event)">

  <mat-step>
    <h1>Welcome! we are so happy that you are interested in studying in Germany.</h1>
    <p>It used to be a hard and painful process for so many of you, needing to use consultancies and spend a lot of money. But we guide you for free. Chapter by chapter we guide you through the process. In every chapter we have a webinar for you and documents prepared. If anything is unclear just contact Manuel.
      Let’s begin?</p>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-button matStepperPrevious disabled>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" matStepperNext (click)="buttonClicked('Chapter 1')">Next</button>
      </mat-grid-tile>
    </mat-grid-list>

  </mat-step>

  <mat-step>
    <h1>Basics about studying in Germany</h1>
    <p>Great! You have made the decision to learn a little more about studying in Germany! So fulfill your task for this chapter. Then you can continue to the next level!</p>
    <mat-grid-list cols="1" rowHeight="20px">
      <mat-grid-tile style="background-color: grey; color: white;">Tasks in this chapter:</mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="2" rowHeight="150px">
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          1. Attend
        </mat-grid-tile-header>
        <a href="https://www.eventbrite.de/e/basics-about-studying-in-germany-tickets-156754054597" target="_blank" type="button" mat-stroked-button color="primary">Webinar</a>
      </mat-grid-tile>
      <!-- <table mat-table>
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let element"> Hi</td>
        </ng-container>
      </table> -->
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          2. Read
        </mat-grid-tile-header>
        <div class="stacked">
          <a href="https://docs.google.com/document/d/1Uqx4-7eiGPt8vxtvvLZZ7IYIND01oTT7kk8rxkn-ccY/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">FAQ</a>
          <a href="https://docs.google.com/document/d/1luaEzyDD-lTw5M9P3ozDtPE8Vn76xFa0BnPJ-ws3NQQ/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Financing</a>
          <a href="https://docs.google.com/document/d/13vpsKxVR7ungJgv5i6bVgQUjNQP-65eRHc2EXViHqoU/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Masters in Germany</a>
          <a href="https://docs.google.com/document/d/1okB9yH7zHhXid26oIxbUrPsoSosSfXbdQrtNztkWRFU/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">GRE/IELTS</a>
        </div>
      </mat-grid-tile>
    </mat-grid-list>

    <app-bottom-buttons></app-bottom-buttons>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-button matStepperPrevious>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" matStepperNext (click)="buttonClicked('Chapter 2')">Next</button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-step>

  <mat-step>
    <!-- <form [formGroup]="firstFormGroup">
      <ng-template matStepLabel></ng-template>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
      </mat-form-field>
      <div>
        <button mat-button matStepperNext>Next</button>
      </div>
    </form> -->
    <h1>Selecting your courses and universities</h1>
    <p>Alright you have made it one step further. <br>You now have the basic infos completed and have an overview how studying in Germany will be!</p>
    <p>Click on the university button! Here you can select universities based on your profile</p>
    <mat-grid-list cols="1" rowHeight="20px">
      <mat-grid-tile style="background-color: grey; color: white;">Tasks in this chapter:</mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="4" rowHeight="150px">
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          1. Attend
        </mat-grid-tile-header>
        <a href="https://www.eventbrite.de/e/26-selecting-your-courses-and-universities-tickets-155676204719" target="_blank" type="button" mat-stroked-button color="primary">Webinar</a>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          2. Read
        </mat-grid-tile-header>
        <a href="https://docs.google.com/document/d/1OBwqQOqj1FkvW-5rau-qK6n0VxKT4MIMNWl8uU00MvI/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Article</a>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          3. Select
        </mat-grid-tile-header>
        <div class="stacked">
          <a href="http://university-finder.surge.sh/" target="_blank" type="button" mat-raised-button color="accent">University</a>
        </div>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          4. Calculate
        </mat-grid-tile-header>
        <div class="stacked">
          <a href="https://docs.google.com/spreadsheets/d/1rEubsT6wWuH5n8ukkq-bnzExF7e6cup-mGip4Ddxnmk/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">ECTS</a>
        </div>
      </mat-grid-tile>
    </mat-grid-list>

    <app-bottom-buttons></app-bottom-buttons>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-raised-button color="primary" matStepperPrevious>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" matStepperNext (click)="buttonClicked('Chapter 3')">Next</button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-step>

  <mat-step>
    <h1>How to prepare your application    </h1>
    <p>And again you have come your goal one step closer. Congratulations. Now you have selected courses and unis you like. Now we need to prepare for them. If you are afraid of this process because you think you have low grades. Don’t be. With a great LOM you can move mountains. So now go ahead and read the document how to prepare your application. Also attend the next webinar to this topic.</p>
    <mat-grid-list cols="1" rowHeight="20px">
      <mat-grid-tile style="background-color: grey; color: white;">Tasks in this chapter:</mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="2" rowHeight="150px">
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          1. Attend
        </mat-grid-tile-header>
        <a href="https://www.eventbrite.de/e/36-how-to-prepare-your-application-tickets-155677757363" target="_blank" type="button" mat-stroked-button color="primary">Webinar</a>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          2. Read
        </mat-grid-tile-header>
        <a href="https://docs.google.com/document/d/1SQbWG9isL2ex2HWxQxihp2ISQl2foMfAEa59Y-ZVIgY/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Prepare Application</a>
      </mat-grid-tile>
    </mat-grid-list>

    <app-bottom-buttons></app-bottom-buttons>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-raised-button color="primary" matStepperPrevious>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" matStepperNext (click)="buttonClicked('Chapter 4')">Next</button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-step>

  <mat-step>
    <h1>Applying at your chosen universities</h1>
    <p>Step by step we are moving towards our goal. Isn’t it amazing? Maybe you can text Manuel and let him know what you think so far? Has this guide been helpful to you? In this chapter we are going to apply at the universities you have selected. Make sure to read the document first and also attend our webinar!</p>
    <mat-grid-list cols="1" rowHeight="20px">
      <mat-grid-tile style="background-color: grey; color: white;">Tasks in this chapter:</mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="2" rowHeight="150px">
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          1. Attend
        </mat-grid-tile-header>
        <a href="https://www.eventbrite.de/e/46-applying-at-your-chosen-universities-tickets-154189387609" target="_blank" type="button" mat-stroked-button color="primary">Webinar</a>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          2. Read
        </mat-grid-tile-header>
        <a href="https://docs.google.com/document/d/1gFe2ZfUnXNhn_-nkdM0sqFef6quH2PXD71-vm4n6XeI/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Applying at University</a>
      </mat-grid-tile>
    </mat-grid-list>

    <app-bottom-buttons></app-bottom-buttons>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-raised-button color="primary" matStepperPrevious>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" matStepperNext (click)="buttonClicked('Chapter 5')">Next</button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-step>

  <mat-step>
    <h1>Applying for a german student visa    </h1>
    <p>Wow. If you made it so far I believe it is time for congratulations. You received a letter of admission. That's amazing. We are basically on the finishing line. Just a few more steps. Now it is time to get a german student visa. Make sure to read the document and attend the webinar to this topic!    </p>
    <mat-grid-list cols="1" rowHeight="20px">
      <mat-grid-tile style="background-color: grey; color: white;">Tasks in this chapter:</mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="2" rowHeight="150px">
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          1. Attend
        </mat-grid-tile-header>
        <a href="https://www.eventbrite.de/e/copy-of-step-56-applying-for-a-german-student-visa-tickets-154190372555" target="_blank" type="button" mat-stroked-button color="primary">Webinar</a>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          2. Read
        </mat-grid-tile-header>
        <a href="https://docs.google.com/document/d/1P-pEpEU3eS4Ybti4nPle_kSscBnxJ_c3PFStDFVvSoc/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Obtain a German Student Visa</a>
      </mat-grid-tile>
    </mat-grid-list>

    <app-bottom-buttons></app-bottom-buttons>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-raised-button color="primary" matStepperPrevious>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" matStepperNext (click)="buttonClicked('Chapter 6')">Next</button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-step>

  <mat-step>
    <h1>Getting started in Germany    </h1>
    <p>Wow this is seriously amazing. You also received the visa. Now it is time to prepare you for your stay in Germany. We can imagine you are a little nervous, but don’t be. Be excited. Everything will go really well. Just check out our next webinar and read the last document, to prepare you perfectly.    </p>
    <mat-grid-list cols="1" rowHeight="20px">
      <mat-grid-tile style="background-color: grey; color: white;">Tasks in this chapter:</mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="2" rowHeight="150px">
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          1. Attend
        </mat-grid-tile-header>
        <a href="https://us02web.zoom.us/j/82783782860?pwd=dFczOXFxNC82MW4zM2ZDckx2Qkt0dz09" target="_blank" type="button" mat-stroked-button color="primary">Webinar</a>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-grid-tile-header style="height: 30px;">
          2. Read
        </mat-grid-tile-header>
        <a href="https://docs.google.com/document/d/1Lj_8yjOqBsg-JkM0Dll9K1a1tCZUqvgkQxx3RCNh9hQ/edit?usp=sharing" target="_blank" type="button" mat-stroked-button color="primary">Getting Started in Germany</a>
      </mat-grid-tile>
    </mat-grid-list>

    <app-bottom-buttons></app-bottom-buttons>

    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile>
        <button mat-raised-button color="primary" matStepperPrevious>Back</button>
      </mat-grid-tile>
      <mat-grid-tile>
          <button mat-raised-button color="primary" (click)="openModal(mytemplate); buttonClicked('Finished') ">Next</button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-step>

  <!-- <mat-step [stepControl]="secondFormGroup" label="Fill out your address">
    <form [formGroup]="secondFormGroup">
      <mat-form-field>
        <mat-label>Address</mat-label>
        <input matInput formControlName="secondCtrl" placeholder="Ex. 1 Main St, New York, NY"
               required>
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Done</ng-template>
    <p>You are now done.</p>
    <div>
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button (click)="stepper.reset()">Reset</button>
    </div>
  </mat-step> -->

  <ng-template #mytemplate>
    <h1>Congratulations</h1>
    <p>You completed the program for studying in Germany. Was this so hard? Could you have imagined a few months ago? Please let us know if this was helpful. We wish you all the best and hopefully stay in touch :)</p>
  </ng-template>

</mat-horizontal-stepper>
